document.addEventListener("DOMContentLoaded", function () {
  BOLD.common.eventEmitter.on(
    "BOLD_OPTIONS_option_products_loaded",
    function (event) {
      const inputs = document.querySelectorAll('.bold_option_number input[type="number"]');
      const extensions = document.querySelectorAll('.bold_option_textbox input[type="text"]');
      let maximum;
      let maxExtension;
      const title = document.querySelector(".m-product-title").textContent;

      switch (title) {
        case "InvisiLights Demo Kit":
          maximum = 1;
          invisiLights();
          extensionsDo();
          break;
        case "InvisiLights 100' Kit":
          maximum = 19;
          maxExtension = 30;
          invisiLights();
          extensionsDo();
          break;
        case "InvisiLights 150' Kit":
          maximum = 27;
          maxExtension = 45;
          invisiLights();
          extensionsDo();
          break;
        case "InvisiLights 200' Kit":
          maximum = 36;
          maxExtension = 65;
          invisiLights();
          extensionsDo();
          break;
        case "InvisiLights 250' Kit":
          maximum = 44;
          maxExtension = 75;
          invisiLights();
          extensionsDo();
          break;
        case "InvisiLights 300' Kit":
          maximum = 52;
          maxExtension = 90;
          invisiLights();
          extensionsDo();
          break;
        default:
          console.error("Product not InvisiLights");
      }

      function invisiLights() {
        const counter = document.createElement("div");
        counter.classList.add("bold-custom");
        document.querySelector(".bold_option_number").parentElement.insertBefore(counter,document.querySelector(".bold_option_number"));
        counter.textContent = "Channels: " + "0" + " | " + maximum;

        function checkAmount(lastOne) {
          let total = 0;
          inputs.forEach((input) => {
            if (input.value != "") {
              total += parseInt(input.value);
            }
          });
          if (total >= maximum) {
            lastOne.value = lastOne.value - (total-maximum);
            total = maximum;
            counter.classList.add("bold-custom-warning");
            setTimeout(() => {
              counter.classList.remove("bold-custom-warning");
            }, 1000);
            inputs.forEach((input) => {
              if (input.value != "") {
                input.setAttribute("max", input.value);
              } else {
                input.setAttribute("max", 0);
              }
            });
          } else {
            inputs.forEach((input) => {
              input.removeAttribute("max");
            });
          }
          counter.textContent = "Channels: " + total + " | " + maximum;
        }

        inputs.forEach((input) => {
          let span = document.createElement("span");
          span.textContent = "Quantity: ";
          input.parentElement.insertBefore(span, input);
          input.setAttribute("min", 0);
          input.addEventListener("input", (event)=>{
            checkAmount(event.target);
          });
          input.parentElement.parentElement.insertBefore(input.parentElement.parentElement.nextElementSibling,input.parentElement);
        });
      }

              function extensionsDo(){
          const extCounter = document.createElement('div');
          extCounter.classList.add('bold-custom');
          document.querySelector('.bold_option_textbox').parentElement.insertBefore(extCounter,document.querySelector('.bold_option_textbox'));
          extCounter.textContent = "Extensions: " + "0ft | " + maxExtension + "ft";

        function preventExtensionsOver(){
           let total = 0;
          extensions.forEach((ext)=>{
            if(ext.value != ""){
              let cableLen = parseInt(ext.parentElement.parentElement.firstElementChild.textContent.replace(/[^0-9]/g, ""));
              total += parseInt(ext.value) * cableLen;
            }
          })
          extCounter.textContent = "Extensions: " + total + "ft | " + maxExtension + "ft";
        }
        
        function extensionCheck(lastOne){
          let total = 0;
          let thisOneCable = parseInt(lastOne.parentElement.parentElement.firstElementChild.textContent.replace(/[^0-9]/g, ""));
          extensions.forEach((ext)=>{
            if(ext.value != ""){
              let cableLen = parseInt(ext.parentElement.parentElement.firstElementChild.textContent.replace(/[^0-9]/g, ""));
              total += parseInt(ext.value) * cableLen;
            }
          })
          if (total > maxExtension){
            lastOne.value = Math.floor(lastOne.value - ((total-maxExtension) / thisOneCable));
            extCounter.classList.add('bold-custom-warning');
            setTimeout(()=>{
              extCounter.classList.remove('bold-custom-warning');
            },1000);
          setTimeout(()=>{preventExtensionsOver()},300);
          } else {
            extensions.forEach((ext) =>{
              ext.removeAttribute('max');
            })
          }
          extCounter.textContent = "Extensions: " + total + "ft | " + maxExtension + "ft";
        }  
        extensions.forEach((ext) =>{
          ext.setAttribute('type','number');
          ext.setAttribute('min',0);
          ext.addEventListener('input',(event)=>{
            extensionCheck(event.target);
          });
          
        })
      }
      
    }
  );
});
